// import React, { useEffect, useMemo, useState } from 'react';
// import { motion } from 'framer-motion';
// import usePageTitle from "../hooks/usePageTitle";

// export default function Login() {
//   const [id, setId] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [showPw, setShowPw] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [remembered, setRemembered] = useState(null); // { id, name, image, role }

//   useEffect(() => {
//     try {
//       const saved = JSON.parse(localStorage.getItem('user') || 'null');
//       const savedId = localStorage.getItem('sliitid') || (saved && saved.SLIITID) || '';
//       if (savedId) {
//         setRemembered({
//           id: savedId,
//           name: saved?.name || 'Leo Member',
//           image: saved?.image || '/user.png',
//           role: saved?.role || ''
//         });
//         setId(savedId);
//       }
//     } catch {}
//   }, []);

//   const avatarSrc = useMemo(() => (remembered?.image ? remembered.image : '/user.png'), [remembered]);

//   const switchToAnotherUser = () => {
//     setRemembered(null);
//     setPassword('');
//     setError('');
//     setId('');
//   };

//   const handleLogin = async (e) => {
//     e.preventDefault();
//     const submitId = remembered ? remembered.id : id;
//     if (!submitId || !password) {
//       setError('SLIIT ID and Password are required');
//       return;
//     }
//     setError('');
//     setLoading(true);
//     try {
//       const res = await fetch('https://dev.sliitleo.org/Backend/login.php', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ SLIITID: submitId, AccountPassword: password })
//       });
//       let data = {};
//       try { data = await res.json(); } catch {}
//       if (data.success) {
//         const userData = {
//           SLIITID: submitId,
//           name: data.full_name ?? (remembered?.name || 'Leo Member'),
//           address: data.address ?? '',
//           contactno: data.contactno ?? '',
//           role: data.role ?? '',
//           image: data.image ?? remembered?.image ?? '/user.png',
//         };
//         localStorage.setItem('user', JSON.stringify(userData));
//         localStorage.setItem('sliitid', submitId);
//         if ((userData.role || '').toLowerCase() === 'banned') {
//           window.location.href = '/restricted';
//         } else {
//           window.location.href = '/home';
//         }
//       } else {
//         setError(data.error || data.message || 'Login failed');
//       }
//     } catch {
//       setError('Server error');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const Dot = ({ className = '' }) => (
//     <span className={`absolute w-3 h-3 rounded-full ring-2 ring-black/40 ${className}`} />
//   );

//   // Animation presets
//   const slideIn = {
//     initial: { x: -40, opacity: 0, scale: 0.98 },
//     animate: { x: 0, opacity: 1, scale: 1 },
//     transition: { duration: 0.35, ease: 'easeOut' }
//   };

//   return (
//     <div className="min-h-screen relative overflow-hidden bg-black text-white">
//       {/* Background Image */}
//       <img
//         src="/8.png"
//         alt=""
//         className="pointer-events-none select-none absolute inset-0 w-full h-full object-cover opacity-20"
//       />

//       {/* Full-page SVG WAVE */}
//       <svg
//         className="absolute inset-0 w-full h-full"
//         viewBox="0 0 1440 900"
//         preserveAspectRatio="xMidYMid slice"
//         aria-hidden
//       >
//         <defs>
//           <linearGradient id="bgWave" x1="0" x2="1" y1="0" y2="1">
//             <stop offset="0%" stopColor="#e11d2e" stopOpacity="0.18" />
//             <stop offset="50%" stopColor="#7a0d18" stopOpacity="0.20" />
//             <stop offset="100%" stopColor="#ff4757" stopOpacity="0.18" />
//           </linearGradient>
//           <filter id="bgGlow" x="-50%" y="-50%" width="200%" height="200%">
//             <feGaussianBlur stdDeviation="22" result="blur" />
//             <feMerge>
//               <feMergeNode in="blur" />
//               <feMergeNode in="SourceGraphic" />
//             </feMerge>
//           </filter>
//         </defs>
//         <rect width="1440" height="900" fill="transparent" />
//         <path d="M0,720 C220,700 320,780 540,740 C760,700 880,560 1100,600 C1260,630 1350,700 1440,680 L1440,900 L0,900 Z"
//               fill="url(#bgWave)" opacity="0.45" filter="url(#bgGlow)" />
//         <path d="M0,690 C240,660 360,750 560,720 C780,690 920,580 1140,620 C1290,650 1380,710 1440,690 L1440,900 L0,900 Z"
//               fill="url(#bgWave)" opacity="0.30" />
//         <path d="M0,760 C240,740 380,820 580,790 C780,760 940,620 1160,660 C1310,690 1400,760 1440,760 L1440,900 L0,900 Z"
//               fill="url(#bgWave)" opacity="0.22" />
//         <path fill="none" stroke="#ff9aa2" strokeOpacity="0.55" strokeWidth="1.6">
//           <animate attributeName="d" dur="7s" repeatCount="indefinite"
//             values="
//               M0,640 C200,600 400,680 600,640 C800,600 1000,680 1200,640 C1320,620 1380,630 1440,640;
//               M0,630 C200,650 400,600 600,650 C800,600 1000,640 1200,650 C1320,640 1380,650 1440,630;
//               M0,640 C200,600 400,680 600,640 C800,600 1000,680 1200,640 C1320,620 1380,630 1440,640
//             " />
//         </path>
//       </svg>

//       {/* LEFT dark gradient overlay */}
//       <div className="absolute inset-0 pointer-events-none">
//         <div className="hidden lg:block absolute inset-y-0 left-0 w-[56%] bg-gradient-to-br from-[#050505]/85 via-[#050505]/65 to-transparent" />
//         <div className="lg:hidden absolute top-0 left-0 right-0 h-1/3 bg-gradient-to-b from-[#050505]/85 via-[#050505]/40 to-transparent" />
//       </div>

//       {/* CONTENT */}
//       <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 min-h-screen">
//         {/* LEFT: auth block (lifted up slightly) */}
//         <div className="flex items-center justify-center px-4 pt-8 pb-10 lg:pt-0">
//           <motion.div
//             {...slideIn}
//             className="w-full max-w-md -mt-4 lg:-mt-10"  /* 👈 lifted up */
//           >
//             <div className="bg-[#050505]/80 backdrop-blur-xl rounded-2xl p-8 shadow-[0_20px_80px_-40px_rgba(0,0,0,.9)] ring-1 ring-white/10">
//               {/* Header */}
//               <div className="flex items-center gap-2 mb-6">
//                 <img src="/club.png" alt="Logo" className="h-8" />
//                 <span className="bg-white/10 px-2 py-1 rounded text-xs font-medium">
//                  Club Portal 4.0
//                 </span>
//               </div>

//               <h1 className="text-2xl font-extrabold tracking-tight">
//                 {remembered ? 'Welcome back' : 'Sign in to your account'}
//               </h1>
//               {!remembered && (
//                 <p className="text-sm text-white/60 mt-1">
//                   Not a member yet?{' '}
//                   <a
//                     href="https://members.sliitleo.org/"
//                     className="text-red-300 hover:text-red-200 underline underline-offset-2"
//                   >
//                     Register now
//                   </a>
//                 </p>
//               )}

//               <form onSubmit={handleLogin} className="mt-7 space-y-5">
//                 {/* Remembered identity strip OR ID input */}
//                 {remembered ? (
//                   <div className="flex items-center gap-4 p-3 rounded-xl bg-white/5 ring-1 ring-white/10 relative">
//                     <div className="relative">
//                       <img
//                         src={avatarSrc}
//                         alt={remembered.name}
//                         className="h-12 w-12 rounded-full object-cover ring-2 ring-white/10"
//                         onError={(e) => { e.currentTarget.src = '/user.png'; }}
//                       />
//                       <Dot className="bg-green-500 top-0 -left-1" />
//                       <span className="absolute -right-1 bottom-0 w-4 h-4 rounded-full overflow-hidden ring-2 ring-black/40">
//                         <img src="/club.png" alt="Org" className="w-full h-full object-cover" />
//                       </span>
//                     </div>
//                     <div className="min-w-0">
//                       <div className="text-sm font-semibold truncate">{remembered.name}</div>
//                       <div className="text-xs text-white/60">{remembered.id}</div>
//                     </div>
//                     <button
//                       type="button"
//                       onClick={switchToAnotherUser}
//                       className="ml-auto text-xs text-red-300 hover:text-red-200 underline underline-offset-2"
//                     >
//                       Sign in as another user
//                     </button>
//                   </div>
//                 ) : (
//                   <div>
//                     <label className="block text-sm mb-1 text-gray-300">SLIIT ID</label>
//                     <input
//                       type="text"
//                       className="w-full bg-[#141414] text-white px-4 py-2 rounded-lg focus:outline-none focus:ring-2 focus:ring-red-500"
//                       placeholder="ITXXXXXXXX"
//                       value={id}
//                       onChange={(e) => setId(e.target.value)}
//                       autoComplete="username"
//                     />
//                   </div>
//                 )}

//                 {/* Password with refined eye toggle */}
// <div>
//   <label className="block text-sm mb-1 text-gray-300">Password</label>
//   <div className="relative">
//     <input
//       type={showPw ? 'text' : 'password'}
//       className="w-full bg-[#141414] text-white px-4 py-2 pr-12 rounded-lg 
//                  focus:outline-none focus:ring-2 focus:ring-red-500 
//                  placeholder-gray-500"
//       placeholder="••••••••"
//       value={password}
//       onChange={(e) => setPassword(e.target.value)}
//       autoComplete="current-password"
//     />

//     {/* Eye toggle */}
//     <button
//       type="button"
//       onClick={() => setShowPw((s) => !s)}
//       aria-label={showPw ? 'Hide password' : 'Show password'}
//       style={{
//         position: "absolute",
//         right: "12px",
//         top: "50%",
//         transform: "translateY(-60%)", // 👈 lifts it higher
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         height: "15px",
//         width: "15px",
//         borderRadius: "50%",
//         background: "rgba(255,255,255,0.1)",
//         border: "1px solid rgba(255,255,255,0.2)",
//         transition: "all 0.2s ease"
//       }}
//     >
//       <svg
//         xmlns="http://www.w3.org/2000/svg"
//         fill="none"
//         viewBox="0 0 24 24"
//         strokeWidth={1.6}
//         stroke="white"
//         style={{ height: "16px", width: "16px" }}
//       >
//         {showPw ? (
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="M3 3l18 18M9.88 9.88A3 3 0 0112 9c1.66 0 3 1.34 3 3a3 3 0 01-.88 2.12M15.88 15.88A9.959 9.959 0 0112 17c-5 0-9.27-3-11-7 1.09-2.45 2.97-4.47 5.34-5.73M9.88 9.88L3 3"
//           />
//         ) : (
//           <path
//             strokeLinecap="round"
//             strokeLinejoin="round"
//             d="M1.5 12s3.5-7 10.5-7 10.5 7 10.5 7-3.5 7-10.5 7S1.5 12 1.5 12zM12 15a3 3 0 100-6 3 3 0 000 6z"
//           />
//         )}
//       </svg>

//       {/* Tiny white dot (inline centered) */}
//       <span
//         style={{
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           height: "2px",
//           width: "2px",
//           borderRadius: "20%",
//           backgroundColor: "white",
//           opacity: showPw ? 1 : 0.4,
//           transition: "opacity 0.2s ease"
//         }}
//       />
//     </button>
//   </div>
// </div>


//                 {error && <p className="text-red-400 text-sm">{error}</p>}

//                 <div className="flex items-center justify-between text-sm text-gray-400">
//                   <span />
//                   <a href="/forgot-password" className="text-red-300 hover:text-red-200 underline underline-offset-2">
//                     Forgot your password?
//                   </a>
//                 </div>

//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className="w-full py-2 rounded-lg font-semibold transition
//                              bg-gradient-to-r from-red-600 via-red-600 to-rose-500
//                              hover:from-red-500 hover:via-red-500 hover:to-rose-400
//                              disabled:opacity-60"
//                 >
//                   {loading ? 'Signing in…' : 'Sign in'}
//                 </button>
//               </form>

//               <p className="text-center text-xs mt-6 text-gray-500">SLIIT Leo කුලේ </p>
//             </div>
//           </motion.div>
//         </div>

//         {/* RIGHT extras (waves already full-screen) */}
//         <div className="relative hidden lg:block">
//           <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-red-600/20 blur-3xl pointer-events-none" />
//           <div className="absolute bottom-10 -left-16 w-[360px] h-[360px] rounded-full bg-rose-500/20 blur-3xl pointer-events-none" />
//           <div className="absolute top-8 right-8 p-3 rounded-2xl bg-white/5 ring-1 ring-white/10 backdrop-blur-md">
//             <div className="flex items-center gap-3">
//               <img src="/club.png" alt="Club" className="h-8 w-8 rounded-md" />
//               <div className="leading-tight">
//                 <div className="text-xs text-white/60">Powered by</div>
//                 <div className="font-semibold">Leo Club of SLIIT</div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Mobile info block */}
//         <div className="lg:hidden px-6 pb-10 -mt-4">
//           <div className="rounded-2xl overflow-hidden ring-1 ring-white/10 bg-white/5">
//             <div className="p-5 text-sm text-white/70">
//               <div className="flex items-center gap-2">
//                 <img src="/club.png" alt="Club" className="h-5 w-5" />
//                 <span>Experience the new Portal 4.0</span>
//               </div>
//               <div className="mt-3 text-white/60">
//                 Experience the next generation of Leo engagement with our upgraded Portal 4.0.
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Footer */}
//       <div className="absolute bottom-2 right-4 text-xs text-gray-400 z-10">
//         <img src="/club.png" alt="Leo Logo" className="inline h-4 mr-1" />
//         Leo Club of SLIIT, Lions International, District 306 D6
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import usePageTitle from "../hooks/usePageTitle";
import { setToken } from '../utils/api';

export default function Login() {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [remembered, setRemembered] = useState(null); // { id, name, image, role }
  const [firstTimeTip, setFirstTimeTip] = useState(false);

  // ---------- Forced CSS (glassier card, white input text, blue hover) ----------
  const forcedCss = `
    @import url('https://fonts.googleapis.com/css2?family=Lato:wght@700;900&display=swap');

    :root{
      --navy-900: #050505;
      --ring-soft: rgba(255,255,255,.12);
      --red-300: #ff9aa2;
      --red-400: #ff4757;
      --red-500: #e11d2e;
    }
    .lato-bold{
      font-family:'Lato',system-ui,-apple-system,'Segoe UI',Roboto,Ubuntu,Cantarell,'Helvetica Neue',Arial;
      font-weight:900; letter-spacing:.2px;
    }

    /* ---- iOS glass card (frosted, tinted, hairline gradient border) ---- */
.card-navy{
  position: relative;
  /* Transparent dark tint + subtle vertical sheen */
  background:
    linear-gradient(180deg, rgba(255,255,255,.06), rgba(255,255,255,.02)) ,
    rgba(20, 8, 10, .28);
  border-radius: 16px;

  /* Hairline base border (will be enhanced by ::before) */
  border: 1px solid rgba(255,255,255,.18);

  /* True glass: heavy blur + saturation like iOS */
  -webkit-backdrop-filter: saturate(160%) blur(26px);
  backdrop-filter: saturate(160%) blur(26px);

  /* Depth + inner lift */
  box-shadow:
    0 24px 80px -36px rgba(20, 4, 6, .65),
    inset 0 1px 0 rgba(255,255,255,.10),
    inset 0 -1px 0 rgba(255,255,255,.04);

  overflow: hidden; /* keep pseudo-elements clipped */
  transition: border-color .20s ease, box-shadow .20s ease, background .25s ease;
}

/* Gradient *border* ring + corner light using masking (retina hairline) */
.card-navy::before{
  content:"";
  position:absolute; inset:0; border-radius: inherit;

  /* soft corner glow + faint top sheen */
  background:
    radial-gradient(120% 100% at 0% 0%, rgba(255,138,148,.18), transparent 55%),
    radial-gradient(120% 100% at 100% 0%, rgba(225,29,46,.12), transparent 60%),
    linear-gradient(180deg, rgba(255,255,255,.08), rgba(255,255,255,0));

  /* turn this layer into a 1px gradient border via mask */
  padding: 1px;
  -webkit-mask:
    linear-gradient(#000 0 0) content-box,
    linear-gradient(#000 0 0);
  -webkit-mask-composite: xor;
          mask-composite: exclude;

  pointer-events:none;
  opacity:.95;
}

/* Micro-noise for realistic glass (very subtle) */
.card-navy::after{
  content:"";
  position:absolute; inset:0; border-radius: inherit;
  background:
    radial-gradient(1px 1px at 20% 30%, rgba(255,255,255,.025) 0 99%, transparent 100%),
    radial-gradient(1px 1px at 70% 60%, rgba(255,255,255,.02) 0 99%, transparent 100%),
    radial-gradient(1px 1px at 40% 80%, rgba(0,0,0,.02) 0 99%, transparent 100%);
  mix-blend-mode: overlay;
  opacity:.35;
  pointer-events:none;
}

/* Hover: slightly brighter border + deeper shadow, like lifted glass */
.card-navy:hover{
  border-color: rgba(255,138,148,.28);
  box-shadow:
    0 28px 90px -34px rgba(122,13,24,.55),
    inset 0 1px 0 rgba(255,255,255,.12),
    inset 0 -1px 0 rgba(255,255,255,.05);
}

/* Fallback if backdrop-filter is unsupported: a bit more opaque so text stays legible */
@supports not ((-webkit-backdrop-filter: blur(1px)) or (backdrop-filter: blur(1px))) {
  .card-navy{
    background: rgba(20,8,10,.55);
  }
}


    /* ---- Inputs: ensure white text + light-blue hover/focus ---- */
    .ios-field{
      background: rgba(24,10,11,.88);
      border: 1px solid rgba(180,160,162,.18);
      color: #fff !important;                 /* 👈 password clearly visible */
      caret-color: var(--red-300);
      transition: border-color .18s ease, box-shadow .18s ease, background .18s ease;
    }
    .ios-field::placeholder{ color: rgba(209,213,219,.45); }
    .ios-field:hover{
      border-color: rgba(255,71,87,.55);     /* light blue hover */
      box-shadow: 0 0 0 2px rgba(255,71,87,.18);
    }
    .ios-field:focus{
      outline: none !important;
      border-color: rgba(255,71,87,.65);     /* brighter blue focus */
      box-shadow: 0 0 0 3px rgba(255,71,87,.24);
      background: rgba(24,10,11,.92);
    }

    .btn-navy{
      background: linear-gradient(90deg,#141414,#1c1c1c 60%,#141414);
      border: 1px solid rgba(180,160,162,.18);
      box-shadow: 0 10px 30px -12px rgba(20,8,9,.65);
      transition: transform .15s ease, filter .15s ease;
    }
    .btn-navy:hover{ filter: brightness(1.06); transform: translateY(-1px); }
    .btn-navy:active{ transform: translateY(0); }

    .error-banner{
      background: linear-gradient(180deg, rgba(239,68,68,.12), rgba(239,68,68,.08));
      border: 1px solid rgba(239,68,68,.35);
      color: #fecaca;
    }
    .info-banner{
      background: linear-gradient(180deg, rgba(225,29,46,.12), rgba(225,29,46,.08));
      border: 1px solid rgba(255,71,87,.35);
      color: #ffd9db;
    }

    .eye-btn{
      position:absolute; right:12px; top:50%; transform:translateY(-50%);
      height:28px; width:28px; display:grid; place-items:center; border-radius:999px;
      border:1px solid rgba(255,255,255,.22); background:rgba(255,255,255,.08);
      transition: all .18s ease;
    }
    .eye-btn:hover{ background:rgba(255,255,255,.14); }

    .ring-subtle{ box-shadow: 0 0 0 1px var(--ring-soft) inset; }
    .tiny-dot{ position:absolute; top:50%; left:50%; transform:translate(-50%,-50%); height:2px; width:2px; background:#fff; border-radius:2px; opacity:.7 }

    /* ---- Remembered strip: glassy, full name, no role ---- */
    .remembered-wrap{
      position:relative; border-radius:16px; padding:14px;
      background: rgba(255,255,255,.03);
      border: 1px solid rgba(255,255,255,.16);
      backdrop-filter: blur(22px) saturate(140%);
      -webkit-backdrop-filter: blur(22px) saturate(140%);
      box-shadow: 0 12px 40px -24px rgba(0,0,0,.85), inset 0 1px 0 rgba(255,255,255,.06);
    }
    .remembered-wrap::before{
      content:""; position:absolute; inset:-1px;
      background:
        radial-gradient(600px 140px at 0% 0%, rgba(255,138,148,.10), transparent 55%),
        radial-gradient(320px 160px at 100% 0%, rgba(225,29,46,.08), transparent 60%);
      opacity:.7; pointer-events:none;
    }
    .remembered-name{
      font-weight:800; line-height:1.15; letter-spacing:.2px;
      white-space:normal; word-break:break-word; overflow:visible; /* show FULL name */
    }
    .remembered-id{ font-variant-numeric: tabular-nums; letter-spacing:.3px; }
    .verified-pill{
      display:inline-flex; align-items:center; gap:.35rem;
      border:1px solid rgba(255,255,255,.22);
      background:rgba(255,255,255,.06);
      padding:.1rem .5rem; border-radius:999px;
      font-size:10.5px; color:rgba(255,255,255,.85);
      white-space:nowrap;
    }
    .avatar-elite{
      height:52px; width:52px; border-radius:999px; object-fit:cover;
      box-shadow:0 8px 26px -10px rgba(0,0,0,.8);
      border:2px solid rgba(255,255,255,.12);
    }
    .badge-org{
      position:absolute; right:-2px; bottom:-2px; height:18px; width:18px; border-radius:999px; overflow:hidden;
      border:2px solid rgba(0,0,0,.4); background:rgba(0,0,0,.45); backdrop-filter: blur(4px);
    }
    .dot-online{
      position:absolute; left:-3px; top:-3px; height:12px; width:12px; border-radius:999px;
      background:#22c55e; border:2px solid rgba(0,0,0,.45); animation:pulseDot 1.6s ease-in-out infinite;
    }
    @keyframes pulseDot{ 0%{transform:scale(1);opacity:.95}50%{transform:scale(1.12);opacity:.75}100%{transform:scale(1);opacity:.95} }

    @media (max-width:420px){ .card-pad{ padding:1.0rem!important; } }
  `;

  useEffect(() => {
    try {
      const saved = JSON.parse(localStorage.getItem('user') || 'null');
      const savedId = localStorage.getItem('sliitid') || (saved && saved.SLIITID) || '';
      if (savedId) {
        setRemembered({
          id: savedId,
          name: saved?.name || 'Leo Member',
          image: saved?.image || '/user.png',
          role: saved?.role || ''
        });
        setId(savedId);
      } else {
        setFirstTimeTip(true);
      }
    } catch {
      setFirstTimeTip(true);
    }
  }, []);

  const avatarSrc = useMemo(() => (remembered?.image ? remembered.image : '/user.png'), [remembered]);

  const switchToAnotherUser = () => {
    setRemembered(null);
    setPassword('');
    setError('');
    setId('');
    setFirstTimeTip(true);
  };

  async function fetchWithTimeout(resource, options = {}) {
    const { timeout = 12000 } = options;
    const controller = new AbortController();
    const id = setTimeout(() => controller.abort(), timeout);
    try {
      const response = await fetch(resource, { ...options, signal: controller.signal });
      return response;
    } finally { clearTimeout(id); }
  }

  const handleLogin = async (e) => {
    e.preventDefault();
    const submitId = remembered ? remembered.id : id;
    if (!submitId || !password) { setError('Please enter your SLIIT ID and password.'); return; }
    setError(''); setLoading(true);
    try {
      const res = await fetchWithTimeout('https://dev.sliitleo.org/Backend/login.php', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ SLIITID: submitId, AccountPassword: password }), timeout: 12000
      });
      let data = {};
      try { data = await res.json(); } catch { setError('Unexpected server response. Please try again.'); setLoading(false); return; }
      if (data?.success) {
        const userData = {
          SLIITID: submitId,
          SLIITLeoID: data.SLIITLeoID ?? null,
          name: data.full_name ?? (remembered?.name || 'Leo Member'),
          address: data.address ?? '',
          contactno: data.contactno ?? '',
          role: data.role ?? '',
          image: data.ProfileLink ?? data.image ?? remembered?.image ?? '/user.png',
        };
        localStorage.setItem('user', JSON.stringify(userData));
        localStorage.setItem('sliitid', submitId);
        setToken(data.token);
        if ((userData.role || '').toLowerCase() === 'banned') window.location.href = '/restricted';
        else window.location.href = '/home';
      } else {
        setError(data?.error || data?.message || 'Invalid credentials. Please check your SLIIT ID and password.');
      }
    } catch (err) {
      setError(err?.name === 'AbortError' ? 'The request timed out. Please try again.' : 'Server error. Please try again.');
    } finally { setLoading(false); }
  };

  const Dot = ({ className = '' }) => (
    <span className={`absolute w-3 h-3 rounded-full ring-2 ring-black/40 ${className}`} />
  );

  const slideIn = { initial: { x: -40, opacity: 0, scale: 0.98 }, animate: { x: 0, opacity: 1, scale: 1 }, transition: { duration: 0.35, ease: 'easeOut' } };

  return (
    <div className="min-h-screen relative overflow-hidden bg-black text-white">
      <style dangerouslySetInnerHTML={{ __html: forcedCss }} />

      {/* Background image and waves stay the same */}
      <img src="/8.png" alt="" className="pointer-events-none select-none absolute inset-0 w-full h-full object-cover opacity-20" />
      <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1440 900" preserveAspectRatio="xMidYMid slice" aria-hidden>
        <defs>
          <linearGradient id="bgWave" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#e11d2e" stopOpacity="0.18" />
            <stop offset="50%" stopColor="#7a0d18" stopOpacity="0.20" />
            <stop offset="100%" stopColor="#ff4757" stopOpacity="0.18" />
          </linearGradient>
          <filter id="bgGlow" x="-50%" y="-50%" width="200%" height="200%">
            <feGaussianBlur stdDeviation="22" result="blur" />
            <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
          </filter>
        </defs>
        <rect width="1440" height="900" fill="transparent" />
        <path d="M0,720 C220,700 320,780 540,740 C760,700 880,560 1100,600 C1260,630 1350,700 1440,680 L1440,900 L0,900 Z"
              fill="url(#bgWave)" opacity="0.45" filter="url(#bgGlow)" />
        <path d="M0,690 C240,660 360,750 560,720 C780,690 920,580 1140,620 C1290,650 1380,710 1440,690 L1440,900 L0,900 Z"
              fill="url(#bgWave)" opacity="0.30" />
        <path d="M0,760 C240,740 380,820 580,790 C780,760 940,620 1160,660 C1310,690 1400,760 1440,760 L1440,900 L0,900 Z"
              fill="url(#bgWave)" opacity="0.22" />
        <path fill="none" stroke="#ff9aa2" strokeOpacity="0.55" strokeWidth="1.6">
          <animate attributeName="d" dur="7s" repeatCount="indefinite"
            values="M0,640 C200,600 400,680 600,640 C800,600 1000,680 1200,640 C1320,620 1380,630 1440,640;
                    M0,630 C200,650 400,600 600,650 C800,600 1000,640 1200,650 C1320,640 1380,650 1440,630;
                    M0,640 C200,600 400,680 600,640 C800,600 1000,680 1200,640 C1320,620 1380,630 1440,640" />
        </path>
      </svg>

      <div className="absolute inset-0 pointer-events-none">
        <div className="hidden lg:block absolute inset-y-0 left-0 w-[56%] bg-gradient-to-br from-[#050505]/85 via-[#050505]/65 to-transparent" />
        <div className="lg:hidden absolute top-0 left-0 right-0 h-1/3 bg-gradient-to-b from-[#050505]/85 via-[#050505]/40 to-transparent" />
      </div>

      <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 min-h-screen">
        <div className="flex items-center justify-center px-4 pt-8 pb-10 lg:pt-0">
          <motion.div {...slideIn} className="w-full max-w-md -mt-4 lg:-mt-10">
            <div className="card-navy rounded-2xl p-8 card-pad">
              <div className="flex items-center gap-2 mb-6">
                <img src="/club.png" alt="Logo" className="h-8" />
                <span className="bg-white/10 px-2 py-1 rounded text-xs font-medium ring-subtle">Club Portal 4.0</span>
              </div>

              <h1 className={`text-2xl font-extrabold tracking-tight ${remembered ? 'lato-bold' : ''}`}>
                {remembered ? 'Welcome back' : 'Sign in to your account'}
              </h1>
              {!remembered && (
                <p className="text-sm text-white/70 mt-1">
                  Not a member yet?{' '}
                  <a href="https://members.sliitleo.org/" className="text-red-300 hover:text-red-200 underline underline-offset-2">Register now</a>
                </p>
              )}

              {firstTimeTip && (
                <div className="info-banner mt-4 rounded-xl px-4 py-3 text-xs leading-relaxed">
                  <div className="flex items-start gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" className="mt-0.5" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ff9aa2" strokeWidth="2">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 8v8M12 16h.01M12 6h.01"></path>
                    </svg>
                    <div>
                      First time here? Use your <b>SLIIT ID</b>. Your initial password is usually your <b>NIC</b>.
                      If it doesn’t work, use <a href="/forgot-password" className="underline text-red-300 hover:text-red-200">Forgot password</a> to reset.
                    </div>
                  </div>
                </div>
              )}

              <form onSubmit={handleLogin} className="mt-6 space-y-5">
                {remembered ? (
                  <div className="remembered-wrap">
                    <div className="flex items-start gap-4 relative">
                      <div className="relative shrink-0">
                        <img
                          src={avatarSrc}
                          alt={remembered.name}
                          className="avatar-elite"
                          onError={(e) => { e.currentTarget.src = '/user.png'; }}
                        />
                        <span className="dot-online" />
                        <span className="badge-org">
                          <img src="/club.png" alt="Org" className="w-full h-full object-cover" />
                        </span>
                      </div>

                      <div className="min-w-0 flex-1">
                        <div className="flex items-center gap-2 flex-wrap">
                          <div className="remembered-name">{remembered.name}</div>
                          <span className="verified-pill">
                            <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
                              <path d="M20 6l-11 11-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                            verified
                          </span>
                        </div>
                        <div className="remembered-id text-xs text-white/70">{remembered.id}</div>
                      </div>

                      <button
                        type="button"
                        onClick={switchToAnotherUser}
                        className="ml-auto text-xs text-red-300 hover:text-red-200 underline underline-offset-2 whitespace-nowrap"
                      >
                        Not you? Switch
                      </button>
                    </div>
                  </div>
                ) : (
                  <div>
                    <label className="block text-sm mb-1 text-gray-300">SLIIT ID</label>
                    <input
                      type="text"
                      className="ios-field w-full px-4 py-2 rounded-lg placeholder-gray-500"
                      placeholder="ITXXXXXXXX"
                      value={id}
                      onChange={(e) => setId(e.target.value.trim())}
                      autoComplete="username"
                      inputMode="text"
                    />
                  </div>
                )}

                <div>
                  <label className="block text-sm mb-1 text-gray-300">Password</label>
                  <div className="relative">
                    <input
                      type={showPw ? 'text' : 'password'}
                      className="ios-field w-full pl-4 pr-12 py-2 rounded-lg placeholder-gray-500"
                      placeholder="••••••••"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      autoComplete="current-password"
                      inputMode="text"
                    />
                    <button
                      type="button"
                      onClick={() => setShowPw((s) => !s)}
                      aria-label={showPw ? 'Hide password' : 'Show password'}
                      className="eye-btn"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                           fill="none" stroke="white" strokeWidth="1.8" className="h-4 w-4">
                        {showPw ? (
                          <>
                            <path d="M3 3l18 18" strokeLinecap="round" strokeLinejoin="round"/>
                            <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" opacity=".6" />
                            <path d="M14.12 14.12A3 3 0 0 1 12 15a3 3 0 0 1-3-3c0-.8.32-1.52.88-2.05" strokeLinecap="round" strokeLinejoin="round"/>
                          </>
                        ) : (
                          <>
                            <path d="M2 12s4-7 10-7 10 7 10 7-4 7-10 7-10-7-10-7z" />
                            <circle cx="12" cy="12" r="3" />
                          </>
                        )}
                      </svg>
                      <span className="tiny-dot" style={{ opacity: showPw ? 1 : .5 }} />
                    </button>
                  </div>
                </div>

                {error && (
                  <div className="error-banner rounded-xl px-4 py-3 text-sm flex items-start gap-2">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                         viewBox="0 0 24 24" fill="none" stroke="#fecaca" strokeWidth="2"
                         className="mt-0.5">
                      <circle cx="12" cy="12" r="10"></circle>
                      <path d="M12 8v5M12 16h.01"></path>
                    </svg>
                    <div className="leading-snug">
                      <span className="font-medium">We couldn’t sign you in.</span>
                      <div className="opacity-90">{error}</div>
                    </div>
                  </div>
                )}

                <div className="flex items-center justify-between text-sm text-gray-300">
                  <span />
                  <a href="/forgot-password" className="text-red-300 hover:text-red-200 underline underline-offset-2">
                    Forgot your password?
                  </a>
                </div>

                <button
                  type="submit"
                  disabled={loading}
                  className={`btn-navy w-full py-2 rounded-lg font-semibold transition ${loading ? 'opacity-70 cursor-not-allowed' : ''}`}
                >
                  {loading ? 'Signing in…' : 'Sign in'}
                </button>
              </form>

              <p className="text-center text-xs mt-6 text-gray-400">SLIIT Leo කුලේ</p>
            </div>
          </motion.div>
        </div>

        {/* right-side panel unchanged */}
        <div className="relative hidden lg:block">
          <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-red-600/20 blur-3xl pointer-events-none" />
          <div className="absolute bottom-10 -left-16 w-[360px] h-[360px] rounded-full bg-rose-500/20 blur-3xl pointer-events-none" />
          <div className="absolute top-8 right-8 p-3 rounded-2xl bg-white/5 ring-1 ring-white/10 backdrop-blur-md">
            <div className="flex items-center gap-3">
              <img src="/club.png" alt="Club" className="h-8 w-8 rounded-md" />
              <div className="leading-tight">
                <div className="text-xs text-white/60">Powered by</div>
                <div className="font-semibold">Leo Club of SLIIT</div>
              </div>
            </div>
          </div>
        </div>

        {/* mobile info block unchanged */}
        <div className="lg:hidden px-6 pb-10 -mt-4">
          <div className="rounded-2xl overflow-hidden ring-1 ring-white/10 bg-white/5">
            <div className="p-5 text-sm text-white/70">
              <div className="flex items-center gap-2">
                <img src="/club.png" alt="Club" className="h-5 w-5" />
                <span>Experience the new Portal 4.0</span>
              </div>
              <div className="mt-3 text-white/60">
                Experience the next generation of Leo engagement with our upgraded Portal 4.0.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-2 right-4 text-xs text-gray-400 z-10">
        <img src="/club.png" alt="Leo Logo" className="inline h-4 mr-1" />
        Leo Club of SLIIT, Lions International, District 306 D6
      </div>
    </div>
  );
}
